export default __webpack_public_path__ + "static/media/barCode.66e60bb8.svg";